import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import React, { useEffect, useState } from "react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_SPACER_SIZES } from "../../../styles/styles-css-variables";
import { FooterComponent } from "../../../components/FooterComponent/FooterComponent";
import { usePrevious } from "../../../hooks";
import { ThankYouState } from "./thank-you/ThankYouState";
import { RegisterState } from "./register/RegisterState";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import {
  ContentFulComponents,
  ExtractSwarovskiPageData,
  NewsletterLandingPageData,
  NewsletterLandingPageDataData,
  SwarovskiOptikLocaleFrontend,
  type GeneralTranslation,
  type TranslatedValue,
} from "@swo/storefront";
import { Translated } from "../../../domain/translations/translations";

export const NewsletterLandingPageComponent: ReactTFC<{
  currentLanguageIsoCode: string;
  currentCountryIsoCode: string;
  countries: NewsletterLandingPageDataData["countries"];
  languages: NewsletterLandingPageDataData["languages"];

  currentSegment: string;
  segmentLabels: { birding: TranslatedValue; hunting: TranslatedValue; outdoor: TranslatedValue };

  maybeInitialEmailValue: string | undefined;
  headline: React.ReactNode;
  paragraph: React.ReactNode;
  signUpTermsParagraph: React.ReactNode;
  segmentSelectorHeadline: React.ReactNode;
  buttonLabel: React.ReactNode;
  termsAndConditions: { link: string; label: TranslatedValue };
  otherConditions: { link: string; label: TranslatedValue };
  translations: { iAccept: TranslatedValue; and: TranslatedValue };
  components: Array<ContentFulComponents | string>;
  thankYouPageTranslations: { headline: TranslatedValue; paragraph: TranslatedValue; buttonLabel: TranslatedValue };
  generalTranslations: Translated<GeneralTranslation>;
  linkToHomepage: string;
  footer: ExtractSwarovskiPageData<NewsletterLandingPageData>["data"]["footer"];
  localeForNumberFormat: SwarovskiOptikLocaleFrontend;
}> = props => {
  const [state, setState] = useState<"register" | "thank-you">("register");

  const onSignedUp = () => {
    setState("thank-you");
  };

  const prevState = usePrevious(state);
  useEffect(() => {
    if (state === "thank-you" && prevState && prevState === "register") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [state]);

  return (
    <>
      {state === "register" && (
        <RegisterState
          {...props}
          onSignedUp={onSignedUp}
          maybeInitialEmailValue={props.maybeInitialEmailValue}
          countries={props.countries}
          languages={props.languages}
          currentLanguageIsoCode={props.currentLanguageIsoCode}
          currentCountryIsoCode={props.currentCountryIsoCode}
        />
      )}
      {state === "thank-you" && (
        <ThankYouState
          headline={props.headline}
          components={props.components}
          thankYouPageTranslations={props.thankYouPageTranslations}
          generalTranslations={props.generalTranslations}
          linkToHomepage={props.linkToHomepage}
          localeForNumberFormat={props.localeForNumberFormat}
        />
      )}

      <Spacer size={"lg"} />

      <FooterComponent {...props.footer} simplified={state === "register"} />
    </>
  );
};

export const paragraphStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x25,
  css`
    margin-top: 0;
    margin-bottom: ${CSS_SPACER_SIZES.md};

    text-align: center;
  `,
];

export const wrapperStyles = css`
  width: 100%;
  max-width: 800px;

  margin-left: auto;
  margin-right: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
`;
